import { z } from "zod";

export namespace NotificationsModels {
/** 
 * PriorityEnumSchema 
 * @type { enum }
 */
export const PriorityEnumSchema = z.enum(["low", "medium", "high", "critical"]);
export type PriorityEnum = z.infer<typeof PriorityEnumSchema>;
export const PriorityEnum = PriorityEnumSchema.enum;

/** 
 * NotificationActionDtoSchema 
 * @type { object }
 * @property { string } text  
 * @property { string } url  
 */
export const NotificationActionDtoSchema = z.object({ text: z.string(), url: z.string() });
export type NotificationActionDto = z.infer<typeof NotificationActionDtoSchema>;


/** 
 * NotificationDataDtoSchema 
 * @type { object }
 * @property { string } title  
 * @property { string } message  
 * @property { NotificationActionDto } action  
 * @property { string } imageUrl  
 * @property { string } priority  
 * @property { string } type  
 * @property { string } category  
 * @property { object } metadata  
 */
export const NotificationDataDtoSchema = z.object({ title: z.string(), message: z.string(), action: NotificationActionDtoSchema.nullish(), imageUrl: z.string().nullish(), priority: PriorityEnumSchema.nullish(), type: z.string().nullish(), category: z.string().nullish(), metadata: z.object({}).catchall(z.any()).nullish() });
export type NotificationDataDto = z.infer<typeof NotificationDataDtoSchema>;


/** 
 * NotificationDtoSchema 
 * @type { object }
 * @property { string } id  
 * @property { string } type  
 * @property { string } notifiableType  
 * @property { string } notifiableId  
 * @property { NotificationDataDto } data  
 * @property { string } readAt  
 * @property { string } createdAt  
 * @property { string } updatedAt  
 */
export const NotificationDtoSchema = z.object({ id: z.string(), type: z.string(), notifiableType: z.string(), notifiableId: z.string(), data: NotificationDataDtoSchema, readAt: z.iso.datetime({ offset: true }).nullish(), createdAt: z.iso.datetime({ offset: true }), updatedAt: z.iso.datetime({ offset: true }) });
export type NotificationDto = z.infer<typeof NotificationDtoSchema>;


/** 
 * PaginatedNotificationResponseDtoSchema 
 * @type { object }
 * @property { NotificationDto[] } items Items 
 * @property { object[] } order List of order definitions 
 * @property { number } page 1-indexed page number to begin from 
 * @property { string } cursor ID of item to start after 
 * @property { string } nextCursor Cursor for next set of items 
 * @property { number } limit Items per response 
 * @property { number } totalItems Total available items 
 */
export const PaginatedNotificationResponseDtoSchema = z.object({ items: z.array(NotificationDtoSchema), order: z.array(z.object({})).nullish(), page: z.number().nullish(), cursor: z.string().nullish(), nextCursor: z.string().nullish(), limit: z.number(), totalItems: z.number() });
export type PaginatedNotificationResponseDto = z.infer<typeof PaginatedNotificationResponseDtoSchema>;


/** 
 * NotificationFilterDtoSchema 
 * @type { object }
 * @property { boolean } read  
 * @property { string } type  
 * @property { string } notifiableId  
 * @property { string } notifiableType  
 */
export const NotificationFilterDtoSchema = z.object({ read: z.boolean().nullable(), type: z.string().nullable(), notifiableId: z.string().nullable(), notifiableType: z.string().nullable() }).partial();
export type NotificationFilterDto = z.infer<typeof NotificationFilterDtoSchema>;


/** 
 * GetUnreadResponseSchema 
 * @type { array }
 */
export const GetUnreadResponseSchema = z.array(NotificationDtoSchema);
export type GetUnreadResponse = z.infer<typeof GetUnreadResponseSchema>;


}
